import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {IDownloadLinks} from '../../../typings/general';
import {ENTITY_TYPES} from '../../services/albumProvider/albumProviderConstant';
import {BI_SCHEMA} from '../../services/biLogger/biEvents';
import {trackSelector} from '../../store/selectors';
import {useBiLogger} from '../BiProvider/withBiLogger';
import {DownloadLinks} from '../DownloadLinks/DownloadLinks';
import {SmallParagraph} from '../ui/SmallParagraph/SmallParagraph';
import {Title} from '../ui/Title';
import styles from './ThankYou.scss';

export interface Props {
  email?: string;
  entityType: ENTITY_TYPES;
  downloadLinks?: IDownloadLinks;
}

export const ThankYou: React.FunctionComponent<Props> = ({email, entityType, downloadLinks}) => {
  const {t} = useTranslation();
  const biLogger = useBiLogger();
  const track = useSelector(trackSelector);

  const onDownloadClick = useCallback(
    (format: string) => {
      biLogger.log(BI_SCHEMA.player.downloadPage.download.clicked, {
        type: entityType,
        format,
        trackID: track ? String(track.id) : undefined,
      });
    },
    [biLogger, entityType, track],
  );

  const titles = {
    album: 'mgw.thankAlbumTitle',
    single: 'mgw.thankSingleTitle',
    track: 'mgw.thankTrackTitle',
  };
  return (
    <div data-hook="thankYou" role="alert">
      <Title className={styles.thankYouTitle}>{t(titles[entityType])}</Title>
      {downloadLinks ? <DownloadLinks downloadLinks={downloadLinks} onDownloadClick={onDownloadClick} /> : null}
      {email ? <SmallParagraph dataHook="emailSentMessage">{t('mgw.thankEmailSent', {email})}</SmallParagraph> : null}
    </div>
  );
};
